
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { AlertTriangle } from "lucide-react";

export const WatercraftInspections = () => {
  return (
    <RegulationItem 
      value="watercraft-inspections" 
      icon={AlertTriangle}
      title="Mandatory Watercraft Inspections"
    >
      <p className="text-tribal-neutral mb-4">
        Invasive aquatic species, specifically zebra and quagga mussels, could have huge negative impacts on the fisheries, 
        aquatic ecosystems, and economy of the Duck Valley Reservation. Quagga and zebra mussels attach to a variety of surfaces, 
        can clog pipes, ruin boat engines, and significantly reduce available food resources for fish.
      </p>
      <p className="text-tribal-neutral mb-4">
        In an attempt to prevent the introduction of these invasive species, the Tribes are collaborating with the Idaho 
        Department of Agriculture to sustain a mussel prevention program on the Reservation. The Tribes may inspect, and 
        potentially impound, any infested watercraft.
      </p>
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
        <p className="text-tribal-secondary font-medium mb-2">Important Information:</p>
        <ul className="list-disc pl-5 text-tribal-neutral">
          <li>There is a boat inspection station located half a mile south of the Sheep Creek Reservoir turn on Highway 225.</li>
          <li>Help us protect our reservoirs from aquatic invasive species.</li>
          <li className="font-semibold">Clean, Drain, and Dry your boat.</li>
        </ul>
      </div>
    </RegulationItem>
  );
};
